

/* ===== VELANTIS_ACEITES ===== */

(function(){

  var CATS=[["Hoteles",["Vidanta","Vidanta Luxxe","Atelier","Wynn","Aria","MGM","Hard Rock","Bvlgari Tokyo","Royal Champagne","Xcaret","Xcaret Parque"]],["Tiendas",["Innova Sport","Palacio","Zara Home","Muy Mucho","Mahogany Teakwood","Emwa","Lincoln","Abercrombie","Palacio de Hierro","Emwa Joyería"]],["Perfume",["Santal","Bergamote 22","Baccarat","Lime Basil & Mandarin","Aventus","Tobacco Vanille","Erba Pura","Layton","Frenesí","Organs","The Noir 29","Santal 33","Baccarat Rouge 540","Invictus","A&F Fierce","Absolut Leather"]],["Otros",["Car New","Leather","Té Negro Le Labo","Maderas del Mediterráneo","Lino y Aloe","Ámbar Cedro","Japanese Lotus","White Tea","Lino & Aloe"]]], SIZES=[["100 ml",450],["250 ml",900],["1 L",2200]], PYR={"Vidanta":["bergamota, limón","jazmín, flores blancas","maderas blancas, almizcle"],"Vidanta Luxxe":["cítricos, mandarina","flor de azahar, jazmín","ámbar, sándalo"],"Atelier":["lavanda, bergamota","salvia, geranio","cedro, vetiver"],"Wynn":["bergamota, limón","té verde, jazmín","maderas, almizcle"],"Aria":["cítricos, pomelo","flores blancas, jazmín","almizcle, maderas"],"MGM":["cítricos, pimienta rosa","especias, flores","maderas, ámbar"],"Hard Rock":["pimienta, cítricos","cuero, tabaco","maderas, especias"],"Bvlgari Tokyo":["yuzu, bergamota","té verde, bambú, jazmín","madera, almizcle"],"Royal Champagne":["uva, cítricos","flores blancas, durazno","almizcle, maderas"],"Xcaret":["cítricos, coco","flores tropicales, jazmín","madera, almizcle"],"Xcaret Parque":["cítricos, brisa marina","coco, flores","ámbar, maderas"],"Innova Sport":["cítricos, menta","lavanda, especias","maderas, almizcle"],"Palacio":["bergamota, cítricos","flores, especias","cuero, madera"],"Zara Home":["flor de algodón, cítricos","jazmín, flores blancas","ámbar, vainilla, almizcle"],"Muy Mucho":["frutas, cítricos","flores, durazno","vainilla, almizcle"],"Mahogany Teakwood":["bergamota, especias","caoba, teca","cuero, cedro"],"Emwa":["cítricos, pera","flores blancas, jazmín","almizcle, maderas suaves"],"Lincoln":["cítricos, cardamomo","cedro dulce, flores","ámbar, vainilla, maderas"],"Abercrombie":["cítricos, cardamomo","petitgrain, flores","cuero, almizcle, maderas"],"Santal":["cardamomo, cítricos","iris, violeta, cuero","sándalo, papiro, ámbar"],"Bergamote 22":["bergamota, pomelo","petitgrain, jengibre","almizcle, ámbar, incienso"],"Baccarat":["azafrán, jazmín","ámbar gris, madera","cedro, resinas"],"Lime Basil & Mandarin":["lima, mandarina, bergamota","albahaca, jazmín","ámbar, vetiver, pachulí"],"Aventus":["piña, bergamota, manzana","abedul, pachulí, rosa","almizcle, roble, ámbar gris"],"Tobacco Vanille":["tabaco, especias","vainilla, cacao, fruta seca","frutos secos, tonka, madera"],"Erba Pura":["cítricos, frutas dulces","frutas maduras, flores","ámbar, vainilla, almizcle"],"Layton":["manzana, bergamota, mandarina","lavanda, geranio, violeta","vainilla, sándalo, cardamomo"],"Frenesí":["frutos rojos, cítricos","flores blancas, jazmín","vainilla, almizcle"],"Organs":["bergamota, cítricos","flores, especias","maderas, ámbar"],"The Noir 29":["bergamota, higo, laurel","té negro, tabaco","maderas, vetiver, musgo"],"Car New":["cítricos, aldehídos","cuero nuevo, flores","maderas, almizcle"],"Leather":["azafrán, cítricos","cuero, tabaco","ámbar, maderas"],"Té Negro Le Labo":["bergamota, higo, laurel","té negro, tabaco","maderas, vetiver"],"Maderas del Mediterráneo":["cítricos, romero","ciprés, lavanda","cedro, maderas"],"Lino y Aloe":["lino fresco, cítricos","aloe, flores blancas","almizcle, maderas suaves"],"Ámbar Cedro":["cítricos, especias","cedro, incienso","ámbar, vainilla, almizcle"],"Japanese Lotus":["flor de loto, cítricos","té verde, bambú","almizcle, maderas"],"White Tea":["té blanco, cítricos","flores blancas, jazmín","almizcle, maderas suaves"],"Santal 33":["cardamomo, cítricos","iris, violeta, cuero","sándalo, papiro, ámbar"],"Baccarat Rouge 540":["azafrán, jazmín","ámbar gris, madera","cedro, resinas"],"Absolut Leather":["azafrán, cítricos","cuero, tabaco","ámbar, maderas"],"Palacio de Hierro":["bergamota, cítricos","flores blancas, jazmín","ámbar, maderas nobles"],"Emwa Joyería":["cítricos, pera","flores blancas, jazmín","almizcle, maderas suaves"],"Lino & Aloe":["lino fresco, cítricos","aloe, flores blancas","almizcle, maderas suaves"],"Invictus":["notas marinas, toronja (pomelo), mandarina","hoja de laurel, jazmín","ámbar gris, madera de gaiac, musgo de roble, pachulí"],"A&F Fierce":["abeto, limón (lima ácida), naranja, notas marinas, petit grain, cardamomo","romero, lirio de los valles (muguete), jazmín, salvia, rosa","almizcle, vetiver, musgo de roble, palo de rosa de brasil, sándalo"]};

  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

  function cap(s){return String(s||'').replace(/^\s*([a-záéíóúñ])/,function(m,c){return c.toUpperCase();});}

  window.VELANTIS_LHS=window.VELANTIS_LHS||{};

  CATS.forEach(function(g){ g[1].forEach(function(n){

    var p=PYR[n]||['','',''], nt=p.filter(Boolean).join(', ');

    window.VELANTIS_LHS[n]={ name:n, kind:'aceite', eyebrow:g[0]+' · Aceite', img:'oil-ph', sizes:SIZES, notes:nt, pyr:p,

      desc:'Aceite aromático de alta concentración para difusor y espacios.',

      long:'Aceite aromático '+n+' de alta concentración'+(nt?', con notas de '+nt:'')+'. Perfuma tu hogar, tu auto y cualquier espacio con una estela envolvente y de larga duración. Compatible con el difusor Velantis y de uso general. Disponible en 100 ml, 250 ml, 500 ml y 1 litro.' };

  });});

  function card(name,cat){

    var p=PYR[name]||['','',''], nt=p.filter(Boolean).join(', ');

    return '<article class="oil-card" data-lhs="'+esc(name)+'" data-name="'+esc(name)+' · Aceite 100 ml" data-price="450" data-img="oil-ph" data-sub="Aceite para difusor · 100 ml" tabindex="0">'+

      '<div class="oil-img oil-ph"></div>'+

      '<div class="oil-body"><div class="oil-cat">'+esc(cat)+'</div><h3>'+esc(name)+'</h3>'+

      '<p class="oil-desc">Aceite para difusor</p>'+

      (nt?'<p class="oil-notes">'+esc(cap(nt))+'</p>':'')+

      '<div class="oil-price">desde $450 <small>MXN</small></div>'+

      '<button class="add" type="button">Agregar al carrito</button></div></article>';

  }

  function giftMode(){ try{return localStorage.getItem('velantis_oilgift')==='1';}catch(e){return false;} }

  function updateBanner(){ var b=document.getElementById('oilGiftBanner'); if(b) b.hidden=!(giftMode() && /^#\/aceites\/?$/.test(location.hash||'')); }

  function render(){

    var box=document.getElementById('aceitesCatalog'); if(!box) return;

    box.innerHTML='<div class="oil-giftbanner" id="oilGiftBanner" hidden>🎁 Estás eligiendo tu <b>aceite de regalo</b> — toca cualquier aceite y se agrega <b>100&nbsp;ml GRATIS</b> por tu difusor.</div>'+

      CATS.map(function(g){

        return '<div class="oil-group"><div class="oil-group-s">Colección</div><h3 class="oil-group-h">'+esc(g[0])+'</h3>'+

          '<div class="oil-grid">'+g[1].map(function(n){return card(n,g[0]);}).join('')+'</div></div>';

      }).join('');

    if(!box._wired){ box._wired=1;

      box.addEventListener('click',function(e){

        var addBtn=e.target.closest('.add');

        if(addBtn){

          if(giftMode()){

            e.preventDefault(); e.stopImmediatePropagation();

            var c0=addBtn.closest('.oil-card'), nm=((c0.querySelector('h3')||{}).textContent||'').trim();

            if(window.VelantisCart) window.VelantisCart.add({name:nm+' · Aceite 100 ml (Regalo)', price:0, img:'oil-ph', sub:'Aceite de regalo · 100 ml · por tu difusor'});

            try{localStorage.removeItem('velantis_oilgift');}catch(x){}

            updateBanner();

            if(window.VelantisCart&&window.VelantisCart.open) window.VelantisCart.open();

          }

          return;

        }

        var c=e.target.closest('.oil-card'); if(!c) return;

        location.hash='#/lhs/'+encodeURIComponent(c.getAttribute('data-lhs'));

      });

    }

    updateBanner();

    var grid=document.getElementById('aceitesGrid'); if(grid) grid.hidden=true;

    var soon=document.getElementById('aceitesSoon'); if(soon) soon.style.display='none';

  }

  window.addEventListener('hashchange',updateBanner);

  if(document.readyState!=='loading') render(); else document.addEventListener('DOMContentLoaded',render);

})();

